module.exports = __webpack_public_path__ + "static/media/miscellaneous.8cf4732c.svg";